module.exports = __webpack_public_path__ + "img/lisboa-antiga.a55f02ce.jpg";